module.exports = __webpack_public_path__ + "img/SKLB-Comunidad.159eaf6e.png";